export function scrollBotton(event) {
  return (
    event?.target?.scrollHeight -
      event?.target?.clientHeight -
      event?.target?.scrollTop ===
    0
  );
}
